import { api } from '../store/middleware/api'

const extendedApi = api.injectEndpoints({
    endpoints: (build) => ({
        getAllMessages: build.query({
            query: () => ({
                url: `/message`,
                method: "GET",
            }),
        }),
       
    }),
    overrideExisting: false,
})

export const {
    useGetAllMessagesQuery
} = extendedApi